export default function Contact() {
    return(
        <section className="work-in-progress-page" aria-labelledby="contact-title">
            <div className="work-in-progress-content">
                <div className="work-in-progress-copy">
                    <p className="work-in-progress-eyebrow">Contact</p>
                    <h1 id="contact-title">Site in progress</h1>
                    <p>
                        I am working on this page now. Soon it will have the best
                        ways to reach me and connect about projects.
                    </p>
                </div>

                <div className="work-in-progress-visual" aria-hidden="true">
                    {/* Add your working-on-it image here when ready:
                        <img src="/path-to-your-image.png" alt="" />
                    */}
                    <span>Image coming soon</span>
                </div>
            </div>
        </section>
    )
}
